import React from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import ColoredSectionContainer from 'apps/promo/components/common/ColoredSectionContainer';
import { PromoPageContainer } from 'apps/promo/components/common/promo-page-container/PromoPageContainer';
import { PromoRow } from 'apps/promo/components/common/PromoRow/PromoRow';
import HeadingSection from 'apps/promo/components/common/sections/HeadingSection';
import { HeroSection } from 'apps/promo/components/common/sections/HeroSection';
import LoneButtonSection from 'apps/promo/components/common/sections/LoneButtonSection';
import { TilesSection } from 'apps/promo/components/common/sections/TilesSection';
import NotAuthBasePage from 'apps/promo/components/NotAuthBasePage';
import { QuoteTileSmall } from 'apps/promo/components/paysend-money-page/QuoteTileSmall';

const HeadingContainer = styled.div`
    max-width: 792px;
    margin: 0 auto;
`;

const PaysendMoneyPage = (props) => {
    return (
        <PromoPageContainer bgColor="baseColor" noIndent>
            {props.heroTitle && (
                <HeroSection title={props.heroTitle} text={props.heroText} data={props.heroData} btnVariant="primary" noIconBtn promoDarkPage />
            )}
            <ColoredSectionContainer>
                {props.headline1Title && <HeadingSection whiteTitle title={props.headline1Title} text={props.headline1Text} />}
                {props.tiles && <TilesSection data={props.tiles} lang={props.lang} country={props.country} isInvertedBtn />}
                {props.quoteText && (
                    <PromoRow indent={'adaptive-32-48-64'}>
                        <QuoteTileSmall img={props.quoteImg} text={props.quoteText} description={props.quoteDescription} />
                    </PromoRow>
                )}
                {props.headline2Btn && <LoneButtonSection btn={props.headline2Btn} variant={'secondary'} isInverted indentSmall />}
                {(props.headline2Title || props.headline2Text) && (
                    <HeadingContainer>
                        <HeadingSection whiteTitle whiteText title={props.headline2Title} text={props.headline2Text} noTopIndent />
                    </HeadingContainer>
                )}
            </ColoredSectionContainer>
        </PromoPageContainer>
    );
};

const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroText: state.extra?.strapiApi?.hero_block?.text,
        heroData: state.extra?.strapiApi?.hero_block,

        headline1Title: state.extra?.strapiApi?.headline1?.title,
        headline1Text: state.extra?.strapiApi?.headline1?.text,

        tiles: state.extra?.strapiApi?.tiles_section,

        quoteImg: state.extra?.strapiApi?.quote_section?.img?.[0].url,
        quoteText: state.extra?.strapiApi?.quote_section?.text,
        quoteDescription: state.extra?.strapiApi?.quote_section?.description,

        headline2Title: state.extra?.strapiApi?.headline2?.title,
        headline2Text: state.extra?.strapiApi?.headline2?.text,
        headline2Btn: state.extra?.strapiApi?.headline2?.btn,

        lang: state.extra?.strapiApi?.lang,
        country: state.extra?.strapiApi?.country,
    };
};
export default connect(mapStateToProps)(NotAuthBasePage(PaysendMoneyPage));
